import { actions as appActions } from '../features/App/reducer'
import { onIsLoading } from './onLoading'
import { clientLogger } from './observability'

export const onSuccess = (message: string) => {
  clientLogger.info('ui.success_alert', { message })
  window.store.dispatch(
    appActions.onAlert({
      severity: 'success',
      message,
    })
  )
  onIsLoading(false)
}
